import { APP_BASE_HREF, CommonModule, TitleCasePipe } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { AppErrorHandler } from './app-error-handler';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { BusinessModule } from './business/business.module';
import { CoreModule } from './core/core.module';
import { httpInterceptorProviders, unauthenticatedHttpInterceptorProviders } from './http-interceptors';
import { MenuModule } from './menu/menu.module';
import { PortalModule } from './portal/portal.module';
import { PortalDataService } from './portal/services/portal-data.service';
import { SharedModule } from './shared/shared.module';
import { PortalTranslateHttpLoaderService } from './translate/services/portal-translate-http-loader.service';
import { TranslateModule as PortalTranslateModule } from './translate/translate.module';
import { EventModifiersPlugin } from './utils/event-modifiers-plugin';

// AoT requires an exported function for factories
export function HttpLoaderFactory(
  http: HttpClient,
  portalDataService: PortalDataService,
  appBaseHref: string
) {
  return new PortalTranslateHttpLoaderService(http, portalDataService, appBaseHref);
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    LoadingBarHttpClientModule,
    /**
     * ngx-translate
     */
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient, PortalDataService, APP_BASE_HREF],
      },
    }),
    CoreModule,
    SharedModule,
    AppRoutingModule,
    AuthModule,
    PortalTranslateModule,
    MenuModule,
    PortalModule,
    BusinessModule,
  ],
  providers: [
    // Define a custom error handler
    { provide: ErrorHandler, useClass: AppErrorHandler },
    // Define a custom dom event handler
    { provide: EVENT_MANAGER_PLUGINS, useClass: EventModifiersPlugin, multi: true },
    // Ensure base http ref is correctly set
    { provide: APP_BASE_HREF, useValue: environment.production ? '/portal2/' : '/' },
    CookieService,
    TitleCasePipe,
    // HTTP interceptors
    httpInterceptorProviders,
    unauthenticatedHttpInterceptorProviders,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
